import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd  } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private routeSubscription!:Subscription;
  private allowedRoutes: string[] = [
    '/users/app-edite-user-details/',
    '/users'
  ];
  private storageRemoved = false;
  private storageRemovedInq = false;
  private storageRemovedAprt = false;
  private storageRemovedowners=false
  currentRoute2:any


  //new version
  private previousSection: string | null = null;
     
    constructor(private auth: AuthenticationService,public router: Router) {
      if (!this.router) {
        console.error("🚨 Router is undefined!");
        return;
      }
    // this.routeSubscription=this.router.events.subscribe(event => {
    //       if(event instanceof NavigationEnd){
          
    
    //         let currentRoute = event.urlAfterRedirects.replace(/^#/, '');
    
    //         console.log("🔍 Current Route:", currentRoute);
    //         console.log("🚀 Checking if storage should be removed...");
    
        
    //         if (
    //           currentRoute === '/users' || 
    //           /^\/users\/app-edite-user-details\/[a-zA-Z0-9-]+$/.test(currentRoute)
    //         ) {
    //           console.log("✅ Allowed route detected. Keeping LocalStorage.");
    //           this.storageRemoved = false; 
    //         } 
            
    //         else if (!this.storageRemoved) {
    //           console.log("🚨 Leaving allowed routes for the first time. Removing LocalStorage...");
    //           localStorage.removeItem('pageNoUsers');
    //           localStorage.removeItem('first');
    //           localStorage.removeItem('rows');
              
    //           this.storageRemoved = true; 
             
    //         } else  {
              
    //           if(currentRoute === '/inquiries' || 
    //             /^\/inquiries\/view-inquire\/[a-zA-Z0-9-]+$/.test(currentRoute)){
    //               this.storageRemovedInq = false;
    //             }else{
    //               console.log("🚨 Leaving allowed routes for the first time. Removing LocalStorage Inq...");
    //               localStorage.removeItem('pageNoInq');
    //               localStorage.removeItem('firstInq');
    //               localStorage.removeItem('rowsInq');
    //               this.storageRemovedInq = true;
    //             }


    //             if(currentRoute === '/apartments' || 
    //               /^\/apartments\/apartments-details\/[a-zA-Z0-9-]+$/.test(currentRoute)){
    //                 this.storageRemovedAprt = false;
    //               }else{
    //                 console.log("🚨 Leaving allowed routes for the first time. Removing LocalStorage Aprt...");
    //                 localStorage.removeItem('pageNoAprt');
    //                 localStorage.removeItem('firstAprt');
    //                 localStorage.removeItem('rowsAprt');
    //                 this.storageRemovedAprt = true;
    //               }


    //               if(currentRoute === '/owners' || 
    //                 /^\/owners\/owner-profile\/[a-zA-Z0-9-]+$/.test(currentRoute)){
    //                   this.storageRemovedowners = false;
    //                 }else{
    //                   console.log("🚨 Leaving allowed routes for the first time. Removing LocalStorage Owners...");
    //                   localStorage.removeItem('numberPageOwner');
    //                   localStorage.removeItem('firstOwn');
    //                   localStorage.removeItem('rowsOwn');
    //                   this.storageRemovedowners = true;
    //                 }
    //         }
    //       }
    //     })

    
//new version
this.routeSubscription = this.router.events.subscribe(event => {
  if (event instanceof NavigationEnd) {
    const currentRoute = event.urlAfterRedirects.replace(/^#/, '');
    // console.log("🔍 Current Route:", currentRoute);

    let section: string | null = null;

    // ==== USERS ====
    const isUserRoute = (
      currentRoute === '/users' ||
      /^\/users\/app-edite-user-details\/[a-zA-Z0-9-]+$/.test(currentRoute)
    );
    if (isUserRoute) section = 'users';

    // ==== INQUIRIES ====
    const isInquiriesRoute = (
      currentRoute === '/inquiries' ||
      /^\/inquiries\/view-inquire\/[a-zA-Z0-9-]+$/.test(currentRoute)
    );
    if (isInquiriesRoute) section = 'inquiries';

    // ==== APARTMENTS ====
    const isApartmentsRoute = (
      currentRoute === '/apartments' ||
      /^\/apartments\/apartments-details\/[a-zA-Z0-9-]+$/.test(currentRoute) ||
      /^\/apartments\/page\/[a-zA-Z0-9-]+$/.test(currentRoute) ||
      /^\/apartments\/booking\/[a-zA-Z0-9-]+$/.test(currentRoute) 


    );
    if (isApartmentsRoute) section = 'apartments';

    // ==== OWNERS ====
    const isOwnersRoute = (
      currentRoute === '/owners' ||
      /^\/owners\/owner-profile\/[a-zA-Z0-9-]+$/.test(currentRoute) ||  
      /^\/owners\/edit_owner\/[a-zA-Z0-9-]+$/.test(currentRoute)  

    );
    if (isOwnersRoute) section = 'owners';

     // ==== Payments ====
     const isPaymentsRoute = (
      currentRoute === '/payments' ||
      /^\/payments\/invoice\/[a-zA-Z0-9-]+$/.test(currentRoute)
    );
    if (isPaymentsRoute) section = 'payments';

    // ==== Payments ====
    const isCheckInqsRoute = (
      currentRoute === '/checkout-inquire' ||
      /^\/checkout-inquire\/checkout\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]+$/.test(currentRoute) ||
      /^\/checkout-inquire\/booking-details\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]+$/.test(currentRoute) 
    );
    if (isCheckInqsRoute) section = 'checkout-inquire';

     // ==== workers ====
     const isWorkerRoute = (
      currentRoute === '/workers' ||
      /^\/workers\/worker-profile\/[a-zA-Z0-9-]+$/.test(currentRoute) ||  
      /^\/workers\/edit-workers\/[a-zA-Z0-9-]+$/.test(currentRoute) 

    );
    if (isWorkerRoute) section = 'workers';


    // ==== partner ====
    const isPartnerRoute = (
      currentRoute === '/partner' ||
      /^\/partner\/view-partner\/[a-zA-Z0-9-]+$/.test(currentRoute)  ||  
      /^\/partner\/edit-partner\/[a-zA-Z0-9-]+$/.test(currentRoute)  

    );
    if (isPartnerRoute) section = 'partner';

    // ==== message ====
    const isMessageRoute = (
      currentRoute === '/messages' ||
      /^\/messages\/message-tiket\/[a-zA-Z0-9-]+$/.test(currentRoute)  
    );
    if (isMessageRoute) section = 'messages';


    // ==== waiting list ====
    const isWaitRoute = (
      currentRoute === '/waitingList' 
    );
    if (isWaitRoute) section = 'waiting-list';

     // ==== extending list ====
     const isExtenRoute = (
      currentRoute === '/extending' ||
      /^\/inquiries\/view-inquire\/[a-zA-Z0-9-]+$/.test(currentRoute)

    );
    if (isExtenRoute) section = 'extending';


    // ==== issues list ====
    const isIssueRoute = (
      currentRoute === '/Issue_Reports' ||
      /^\/Issue_Reports\/Report-view\/[a-zA-Z0-9-]+$/.test(currentRoute) || 
      /^\/Issue_Reports\/assgin-issue\/[a-zA-Z0-9-]+$/.test(currentRoute)||
      /^\/Issue_Reports\/assgin-issue-owner\/[a-zA-Z0-9-]+$/.test(currentRoute) 

    );
    if (isIssueRoute) section = 'Issue_Reports';



    // 🧹 If switched section → clean old section's storage
    if (this.previousSection && this.previousSection !== section) {
      console.log(`🚨 Switched from ${this.previousSection} to ${section} — cleaning old storage`);

      switch (this.previousSection) {
        case 'users':
          localStorage.removeItem('pageNoUsers');
          localStorage.removeItem('first');
          localStorage.removeItem('rows');
          localStorage.removeItem('userPage');

          break;
        case 'inquiries':
          localStorage.removeItem('pageNoInq');
          localStorage.removeItem('firstInq');
          localStorage.removeItem('rowsInq'); 
          localStorage.removeItem('inqPage');

          break;
        case 'apartments':
          localStorage.removeItem('pageNoAprt');
          localStorage.removeItem('firstAprt');
          localStorage.removeItem('rowsAprt');
          break;
        case 'owners':
          localStorage.removeItem('numberPageOwner');
          localStorage.removeItem('firstOwn');
          localStorage.removeItem('rowsOwn');
          localStorage.removeItem('ownerPage');

          break;
        case 'payments':
          localStorage.removeItem('pageNoPay');
          localStorage.removeItem('firstPay');
          localStorage.removeItem('rowsPay');
          localStorage.removeItem('paymentPage');

          break;
        case 'checkout-inquire':
          localStorage.removeItem('pageNoCheck');
          localStorage.removeItem('firstCheck');
          localStorage.removeItem('rowsCheck');
          localStorage.removeItem('checkPage');

          break;
        case 'workers':
          localStorage.removeItem('pageNoWork');
          localStorage.removeItem('firstWork');
          localStorage.removeItem('rowsWork');
          localStorage.removeItem('workerPage');

          break;
        case 'partner':
          localStorage.removeItem('pageNoPartner');
          localStorage.removeItem('firstPartner');
          localStorage.removeItem('rowsPartner');
          localStorage.removeItem('partnerPage');

          break;

        case 'messages':
          localStorage.removeItem('messagePage');
          break;

        case 'waiting-list':
          localStorage.removeItem('waitPage');
          break;

        case 'extending':
          localStorage.removeItem('extenPage');
          break;

        case 'Issue_Reports':
          localStorage.removeItem('issuePage');
          break;

           
      }
    }

    this.previousSection = section;
  }
});

  }
  ngOnInit(): void {
    this.requestPermission();
    this.listen();
  }
  title = 'StudiFlats';
  message: any = null;
  /*  requestPermission(){
    const messaging=getMessaging();
    getToken(messaging,{vapidKey:environment.firebase.vapidKey}).then(
      (currentToken)=>{
        if(currentToken){
          this.auth.FCMToken(currentToken).subscribe((response: any) => {});
        }
        else{
        }
      }
    )
  } */
  playAudio() {
    let audio = new Audio();
    audio.src = 'http://dev.studiflats.com/assets/bell.wav';

    let audio2: HTMLAudioElement = new Audio(
      'http://dev.studiflats.com/assets/bell.wav'
    );
    audio2.play();
  }
  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: environment.firebase.vapidKey })
      .then((currentToken) => {
        if (currentToken) {
          this.auth.FCMToken(currentToken).subscribe(
            (res) => {},
            (error) => {
              console.error('Error fetching owners:', error);
            }
          );
        } else {

        }
      })
      .catch((err) => {
      });
  }
  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      this.message = payload;
      this.playAudio();
    });
  }


  ngOnDestroy() {
    console.log("🛑 AppComponent Destroyed. Unsubscribing...");
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
